export default "__VITE_ASSET__DdcC1HpM__"